export const SLIDE_NAME = `Слайд №`;
